import React from 'react';
import styles from './CoreValues.module.css';

function CoreValues() {
  return (
    <section className={styles.coreValues}>
      <h2>Our Core Values</h2>
      <ul>
        <li>Responsibility</li>
        <li>Integrity</li>
        <li>Compassion</li>
        <li>Excellence</li>
      </ul>
    </section>
  );
}

export default CoreValues;
